import { Button, StyledButton } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledSocialButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1.6rem;

  a[data-btn='link'] {
    svg {
      width: 2rem;
      height: 1.9rem;
    }
  }
`;

export const StyledSocialWrapper = styled.div`
  text-align: center;
  p {
    color: ${({ theme }) => theme.colors.paragraph};
    font-size: ${({ theme }) => theme.colors.paragraph};
    text-align: center;
    margin-bottom: 2.4rem;
  }
`;

export const StyledGenerateButton = styled(Button)`
  margin: 0 auto 2rem;
`;

export const StyledButtonLink = styled(StyledButton)<{ $isDisabled?: boolean }>`
  ${({ $isDisabled, theme }) =>
    $isDisabled &&
    `
    border-color: ${theme.colors.grey[400]};
    background-color: ${theme.colors.grey[400]};
    color: ${theme.colors.grey[600]};
    cursor: not-allowed;
    
    &:hover:not(:disabled) {
      background-color: ${theme.colors.grey[400]};
      color: ${theme.colors.grey[600]};
    }

    svg path {
     fill: ${theme.colors.grey[600]};
    }
`}
`;
